/**
 * Component to render badges
 */

import { EuiBadge, htmlIdGenerator } from "@inscopix/ideas-eui";
import { useMemo } from "react";
const getId = htmlIdGenerator("multi-badge");

export interface MultiBadgeRendererProps {
  items: string[];
  color?: string;
}

export const MultiBadgeRenderer = ({
  items,
  color = "default",
}: MultiBadgeRendererProps) => {
  const keyedItems = useMemo(
    () => items.map((item) => ({ item, key: getId() })),
    [items],
  );
  return (
    <>
      {keyedItems.map((item) => (
        <EuiBadge key={item.key} color={color}>
          {item.item}
        </EuiBadge>
      ))}
    </>
  );
};
